import traits from './traits';
import components from './components';
import blocks from './blocks';

export default (editor, config, advanced) => {
  components(editor, config);
  blocks(editor, config, advanced);
  traits(editor, config);
};
